import { requestData } from "./utils";

export default class SearchModule {
  search(data) {
    return requestData("GET", "/search/cdr/mt", data);
  }
  lookup(data) {
    return requestData("GET", "/search/sms/lookup", data);
  }
}
